var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildingHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33335 2.37498C6.33335 1.93774 6.68779 1.58331 7.12502 1.58331H13.4584C13.8956 1.58331 14.25 1.93774 14.25 2.37498V11.875H17.4167C17.8539 11.875 18.2084 12.2294 18.2084 12.6666V16.625C18.2084 17.0622 17.8539 17.4166 17.4167 17.4166H1.58335C1.14612 17.4166 0.791687 17.0622 0.791687 16.625V4.74998C0.791687 4.31274 1.14612 3.95831 1.58335 3.95831H6.33335V2.37498ZM7.91669 3.16665V11.875H12.6667V3.16665H7.91669ZM14.25 15.8333V13.4583H16.625V15.8333H14.25ZM6.33335 5.54165H2.37502V7.91665H6.33335V5.54165ZM6.33335 9.49998V11.875H2.37502V9.49998H6.33335ZM6.33335 13.4583H2.37502V15.8333H6.33335V13.4583ZM9.50002 13.4583H7.91669V15.8333H9.50002V13.4583ZM11.0834 15.8333V13.4583H12.6667V15.8333H11.0834Z",
    fill: "#255056",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingHotel);
export default __webpack_public_path__ + "static/media/building_hotel.5bbb827d87551f071874e8bf3c7756a6.svg";
export { ForwardRef as ReactComponent };